/**
 * These mutation keys are stored separately from the rest of the mutation registry
 * to avoid circular dependencies.
 *
 *
 */

/**
 * Mutation key for creating survey site - used for registry lookup.
 * All mutations of this type share this key; individual items are identified
 * by inspecting mutation.state.variables.id
 */
export const CREATE_SURVEY_SITE_MUTATION_KEY = ["surveySites", "create"]

/**
 * Mutation key for creating observation with collection - used for registry lookup.
 * All mutations of this type share this key; individual items are identified
 * by inspecting mutation.state.variables.id
 */
export const CREATE_OBSERVATION_WITH_COLLECTION_MUTATION_KEY = [
  "observations",
  "createWithCollection",
]

/**
 * Mutation key for creating observation - used for registry lookup.
 * All mutations of this type share this key; individual items are identified
 * by inspecting mutation.state.variables.id
 */
export const CREATE_OBSERVATION_MUTATION_KEY = ["observations", "create"]

/**
 * Entity CREATE mutation keys that may contain embedded photos.
 */
export const ENTITY_CREATE_MUTATION_KEYS = [
  CREATE_OBSERVATION_MUTATION_KEY,
  CREATE_OBSERVATION_WITH_COLLECTION_MUTATION_KEY,
  CREATE_SURVEY_SITE_MUTATION_KEY,
]
